<script>
  import { checkbox } from 'vue-strap';
  import radio from '~componentes/Radio.vue';
  import estados from '~js/estados';
  import projetoServico from '~modulos/projeto/servico';
  import tiposQuadro from '~js/tipos-quadro';
  import tiposQuadroUSP from '~js/tipos-quadro-usp';
  import regimesTrabalhoUSP from '~js/regime-trabalho-usp';
  import pessoaServico from '~modulos/acessos/servico';

  export default {
    components: { radio, checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false,
        default: false,
      },
      desabilitarBeneficiario: {
        type: Boolean,
        default: false,
      },
      pertenceQuadroOriginal: {
        type: Boolean,
      },
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        projetos: [],
        rubricas: [],
        subrubricas: [],
        configuracao: this.$storage.configuracao(),

        exibirBolsa: false,
        exibirRPA: false,
        exibirEstagio: false,
        exibirTermoAditivo: false,
        exibirAdicionalVariavel: false,
        tiposQuadro: tiposQuadro,
        tiposQuadroUSP: tiposQuadroUSP,
        regimesTrabalhoUSP: regimesTrabalhoUSP,
        tipoQuadroSolBolsaObrigatorio: false,
        desabilitarEndereco: false,
      }
    },
    methods: {
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      validar() {
        return this.$validator.validateAll();
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolBolsa")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeRubricas(idProjeto) {
        this.solicitacao.idRubrica = '';
        this.solicitacao.idSubrubrica = '';
        this.subrubricas = [];

        return projetoServico
          .rubricas(idProjeto)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas(idProjeto = null, idRubrica = null) {
        idProjeto = this.solicitacao.idProjeto || idProjeto;
        idRubrica = this.solicitacao.idRubrica || idRubrica;

        this.solicitacao.idSubrubrica = '';
        this.subrubricas = [];

        if (!idRubrica) return;

        return projetoServico
          .subrubricas(idProjeto, idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.solicitacao, 'projeto', projeto);
            this.exibirAdicionalVariavel = projeto.realizarPagamentoProvisoes && this.configuracao.exibirAdicionalVariavel;

            if (this.solicitacao.tipoBolsa === 5 && !projeto.realizarPagamentoProvisoes)
              this.solicitacao.tipoBolsa = 1;
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function (e) {
            _this.$set(_this.solicitacao, 'idProjeto', this.value);

            _this.setarProjeto(this.value);
            _this.solicitacao.idContratoTermoAditivo = 0;

            if (!this.value) return;

            _this.listaDeRubricas(this.value);
          });
      },
      requiredTipoQuadroSolBolsaObrigatorio() {

        if (this.configuracao.tipoQuadroSolBolsaObrigatorio) {
          if (this.solicitacao.tipoBolsa === 1) {
            this.solicitacao.pertenceQuadro = true;
            this.tipoQuadroSolBolsaObrigatorio = true;
          }
          else {
            this.solicitacao.pertenceQuadro = this.pertenceQuadroOriginal;
            this.tipoQuadroSolBolsaObrigatorio = false;
          }
        }
      },
      limparCamposTodasSolicitacoes() {
        if (this.carregando)
          exit;

        this.solicitacao.aceite = null;

        if (this.solicitacao.tipoBolsa === 5) {
          this.solicitacao.funcionarioPublico = 1;

          if (this.solicitacao.pertenceQuadroUSP == 1) {
            this.solicitacao.tipoQuadroUSP = 1;
          }
        }
      },
      limparCamposTodasSolicitacoesFUSP() {
        if (this.solicitacao.funcionarioPublico == 0) {
          this.solicitacao.pertenceQuadroUSP = null,
            this.solicitacao.tipoQuadroUSP = null,
            this.solicitacao.regimeTrabalhoUSP = null;
          this.solicitacao.cargo = null;
          this.solicitacao.departamento = null;
          this.solicitacao.unidade = null;
          this.solicitacao.instituicaoPublica = null;
          this.solicitacao.cnpjInstituicaoPublica = null;
          this.solicitacao.cargaHorariaInstituicao = null;
          this.solicitacao.matricula = null;
          this.solicitacao.siafi = null;
        }
      },
      limparCamposPertenceQuadroUSP() {
        if (this.solicitacao.pertenceQuadroUSP == 1) {
          this.solicitacao.instituicaoPublica = null;
          this.solicitacao.cnpjInstituicaoPublica = null;
          this.solicitacao.cargaHorariaInstituicao = null;
          this.solicitacao.siafi = null;

          if (this.solicitacao.tipoBolsa === 5) {
            this.solicitacao.tipoQuadroUSP = 1;
          }
        }
        else {
          this.solicitacao.tipoQuadroUSP = null,
            this.solicitacao.regimeTrabalhoUSP = null;
          this.solicitacao.departamento = null;
          this.solicitacao.unidade = null;
        }
      },
      limparCamposTipoQuadroUSP() {
        if (this.solicitacao.tipoQuadroUSP != 0) {
          if (this.solicitacao.tipoQuadroUSP != 1)
            this.solicitacao.regimeTrabalhoUSP = null;
        }
      },
      limparCamposRegimeTrabalho() {
        if (this.solicitacao.regimesTrabalhoUSP != 1) {
          this.solicitacao.solicitacaoJustificativaAnexo = null;
          this.solicitacao.solicitacaoAnexouArquivo = null
        }
      },
      getCEP() {
        if (this.solicitacao.endereco) return;

        let textoCEP = this.solicitacao.cep.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.endereco = cepObj.logradouro.substring(0, 60);
              this.solicitacao.bairro = cepObj.bairro.substring(0, 60);
              this.solicitacao.cidade = cepObj.localidade.substring(0, 60);
              this.solicitacao.uf = cepObj.uf;
              this.solicitacao.numero = "";
              this.solicitacao.complemento = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
    },
    computed: {
      requiredPertenceQuadroUSP() {
        if (this.solicitacao.funcionarioPublico == 0)
          return false;

        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return false;

        return true;
      },
      visualizarTipoQuadroRegime() {
        if (!this.tipoTodasSolicitacoesFUSP)
          return false;

        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return false;

        if (!this.solicitacao.pertenceQuadroUSP)
          return false;

        return true;
      },
      requiredCNPJInstituicaoPublica() {
        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return 'cnpj';

        return 'required|cnpj';
      },
      requiredInstituicaoPublica() {
        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return '';

        return 'required';
      },
      requiredMatricula() {
        return '';

        if ((this.solicitacao.tipoBolsa == 1) || (this.solicitacao.tipoBolsa == 3))
          return '';

        return 'required';
      },
      validarDataNascimento() {
        return this.configuracao.permitirCadPFSemDataNascimento ? 'date_format:DD/MM/YYYY' : 'required|date_format:DD/MM/YYYY';
      },
      validarInss() {
        let validar = `inss|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 2 && !this.solicitacao.pisPasep)
          validar = `required|inss|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 5 && !this.solicitacao.pisPasep)
          validar = `required|inss|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 1 && !this.solicitacao.pisPasep && this.configuracao.solBolsaObrigatorioPISInss)
          validar = `required|inss|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        return validar;
      },
      validarPisPasep() {
        let validar = `pispasep|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 2 && !this.solicitacao.inss)
          validar = `required|pispasep|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 5 && !this.solicitacao.inss)
          validar = `required|pispasep|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        if (this.solicitacao.tipoBolsa === 1 && !this.solicitacao.inss && this.configuracao.solBolsaObrigatorioPISInss)
          validar = `required|pispasep|inssPisUnico:${this.solicitacao.cpfCnpj}`;

        return validar;
      },
      validarMatricula() {
        if (!this.configuracao.matriculaObrigatoria)
          return '';

        return ((this.solicitacao.tipoBolsa === 1 && !this.solicitacao.siafi) || this.solicitacao.tipoBolsa === 3)
          ? 'required' : '';
      },
      validarSiafi() {
        if (!this.configuracao.siapeObrigatorio)
          return '';

        return (this.solicitacao.tipoBolsa === 1 && !this.solicitacao.matricula)
          ? 'required' : '';
      },
      tipoTodasSolicitacoesFUSP() {
        //return false;

        if (!this.fusp())
          return false;

        if (this.solicitacao.tipoBolsa !== 4) {
          return true;
        }
      },
      exibirRubricaSubrubricaSolicitacaoWeb() {
        return this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || this.solicitacao.projeto.utilizarRubricaSubrubricaWeb;
      }
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');

      this.listaDeProjetos();
      this.iniciarSelect2Projeto();

      this.exibirBolsa = this.configuracao.exibirBolsa;
      this.exibirRPA = this.configuracao.exibirRPA;
      this.exibirEstagio = this.configuracao.exibirEstagio;
      this.exibirTermoAditivo = this.configuracao.exibirTermoAditivo;
      this.requiredTipoQuadroSolBolsaObrigatorio();

      if (!this.editando)
        this.carregandoDados = false;

      const _this = this;


      this.$watch('solicitacao.tipoBolsa', function () {
        _this.limparCamposTodasSolicitacoes();
      })

      this.$watch('solicitacao.cep', function () {
        _this.getCEP();
      })

      this.$watch('solicitacao.funcionarioPublico', function () {
        _this.limparCamposTodasSolicitacoesFUSP();
      })

      this.$watch('solicitacao.pertenceQuadroUSP', function () {
        _this.limparCamposPertenceQuadroUSP();
      })

      this.$watch('solicitacao.tipoQuadroUSP', function () {
        _this.limparCamposTipoQuadroUSP();
      })
    },
    watch: {
      'solicitacao.tipoBolsa': 'requiredTipoQuadroSolBolsaObrigatorio',
    }
  }
</script>

<template>
    <div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('projeto')}" v-if="!edicao">
                    <label class="control-label" for="projeto">Projeto</label>

                    <select id="projeto"
                            class="form-control"
                            v-model="solicitacao.idProjeto"
                            data-vv-name="projeto"
                            v-validate="'required'">
                        <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos"
                                :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolBolsaRpaEstagio) || projeto.acompanhamentoPendente || projeto.inativoDebito">
                            {{ projeto.nomeProjeto }}

                            <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolBolsaRpaEstagio)">
                                (Data limite até: {{ projeto.dataLimiteSolBolsaRpaEstagio | formatarData }})
                            </template>

                            <template v-if="projeto.acompanhamentoPendente && permitirCriarSolicitacao(projeto.dataLimiteSolBolsaRpaEstagio) && !projeto.inativoDebito">
                                (Projeto bloqueado para solicitações, favor responder o acompanhamento deste projeto que está em atraso)
                            </template>

                            <template v-if="projeto.inativoDebito">
                                (Projeto bloqueado para solicitações, pois o projeto está inativo para débito)
                            </template>
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
                </div>

                <div class="form-group required" v-if="edicao">
                    <label class="control-label" for="projeto">Projeto</label>

                    <input type="text"
                           class="form-control"
                           v-model="solicitacao.projeto.nomeProjeto"
                           disabled>
                </div>
            </div>
        </div>

        <div class="row" v-if="exibirRubricaSubrubricaSolicitacaoWeb">
            <div class="col-md-6">
                <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
                    <label class="control-label" for="rubrica">Rubrica</label>

                    <select class="form-control"
                            id="rubrica"
                            v-model="solicitacao.idRubrica"
                            data-vv-name="rubrica"
                            data-vv-as="rubrica"
                            v-validate="'required'"
                            @change="listaDeSubrubricas">
                        <option value="">Selecione...</option>
                        <option :value="rubrica.id"
                                v-for="rubrica in rubricas">
                            {{ rubrica.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
                </div>
            </div>

            <div class="col-md-6">
                <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
                    <label class="control-label" for="subrubrica">Subrubrica</label>

                    <select class="form-control"
                            id="subrubrica"
                            v-model="solicitacao.idSubrubrica"
                            data-vv-name="subrubrica"
                            data-vv-as="subrubrica"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="subrubrica.id"
                                v-for="subrubrica in subrubricas">
                            {{ subrubrica.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group radios">
                    <radio v-model="solicitacao.tipoBolsa"
                           name="tiposBolsa"
                           :selected-value="1"
                           type="success"
                           :inline="true"
                           v-if="exibirBolsa"
                           class="margin-right-10">
                        Bolsa
                    </radio>

                    <radio v-model="solicitacao.tipoBolsa"
                           name="tiposBolsa"
                           :selected-value="2"
                           type="success"
                           :inline="true"
                           v-if="exibirRPA"
                           class="margin-right-10">
                        RPA
                    </radio>

                    <radio v-model="solicitacao.tipoBolsa"
                           name="tiposBolsa"
                           :selected-value="3"
                           type="success"
                           v-if="exibirEstagio"
                           :inline="true">
                        Estágio
                    </radio>

                    <radio v-model="solicitacao.tipoBolsa"
                           name="tiposBolsa"
                           :selected-value="4"
                           type="success"
                           v-if="exibirTermoAditivo"
                           :inline="true">
                        Termo aditivo
                    </radio>

                    <radio v-model="solicitacao.tipoBolsa"
                           name="tiposBolsa"
                           :selected-value="5"
                           type="success"
                           v-if="exibirAdicionalVariavel"
                           :inline="true">
                        Adicional variável
                    </radio>
                </div>
            </div>

        </div>

        <hr class="no-margin-top">

        <div class="row">
            <div class="col-sm-4">
                <div class="form-group required" :class="{'has-error': errors.has('nome')}">
                    <label class="control-label" for="nome">Nome</label>

                    <input type="text"
                           class="form-control"
                           id="nome"
                           v-model="solicitacao.nome"
                           data-vv-name="nome"
                           data-vv-as="Nome"
                           v-validate="'required'"
                           maxlength="100"
                           :disabled="desabilitarBeneficiario">

                    <p class="text-danger" v-show="errors.has('nome')">{{ errors.first('nome') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group" :class="{'has-error': errors.has('nomeSocial')}">
                    <label class="control-label" for="nomeSocial">Nome social</label>

                    <input type="text"
                           class="form-control"
                           id="nomeSocial"
                           v-model="solicitacao.nomeSocial"
                           data-vv-name="nomeSocial"
                           data-vv-as="Nome social">

                    <p class="text-danger" v-show="errors.has('nomeSocial')">{{ errors.first('nomeSocial') }}</p>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-group required">
                    <label class="control-label" for="documento">CPF</label>

                    <input type="text"
                           class="form-control"
                           id="documento"
                           v-model="solicitacao.cpfCnpj"
                           disabled>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-3">
                <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
                    <label class="control-label" for="nascimento">Data de nascimento</label>

                    <input id="nascimento"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.dataNascimento"
                           v-mascara="'data'"
                           placeholder="    /    /"
                           data-vv-name="dataNascimento"
                           data-vv-as="data de nascimento"
                           v-validate="validarDataNascimento">

                    <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group">
                    <label class="control-label" for="identidade">Identidade</label>

                    <input id="identidade"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.identidade"
                           maxlength="20">
                </div>
            </div>

            <div class="col-lg-3" :class="{'has-error': errors.has('inss')}">
                <div class="form-group">
                    <label class="control-label" for="inss">INSS <small class="text-muted">(apenas números)</small></label>

                    <input id="inss"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.inss"
                           v-mascara="'inss'"
                           data-vv-name="inss"
                           data-vv-as="inss"
                           data-vv-delay="1000"
                           v-validate="validarInss">

                    <p class="text-danger" v-show="errors.has('inss')">{{ errors.first('inss') }}</p>
                </div>
            </div>

            <div class="col-lg-3" :class="{'has-error': errors.has('pispasep')}">
                <div class="form-group">
                    <label class="control-label" for="pispasep">PISPASEP <small class="text-muted">(apenas números)</small></label>

                    <input id="pispasep"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.pisPasep"
                           v-mascara="'pispasep'"
                           data-vv-name="pispasep"
                           data-vv-as="pis/pasep"
                           data-vv-delay="1000"
                           v-validate="validarPisPasep">

                    <p class="text-danger" v-show="errors.has('pispasep')">{{ errors.first('pispasep') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3">
                <div class="form-group required" :class="{'has-error': errors.has('cep')}">
                    <label class="control-label" for="cep">CEP</label>

                    <input type="text"
                           class="form-control"
                           id="cep"
                           v-model="solicitacao.cep"
                           data-vv-as="cep"
                           data-vv-name="cep"
                           v-mascara="'cep'"
                           :disabled="desabilitarEndereco"
                           v-validate="'required'">

                    <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
                    <label class="control-label" for="endereco">Endereço</label>

                    <input id="endereco"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.endereco"
                           data-vv-name="endereco"
                           data-vv-as="endereço"
                           :disabled="desabilitarEndereco"
                           v-validate="'required'"
                           maxlength="60">

                    <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group required" :class="{'has-error': errors.has('numero')}">
                    <label class="control-label" for="numero">Número</label>

                    <input id="numero"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.numero"
                           data-vv-name="numero"
                           data-vv-as="número"
                           v-validate="'required'"
                           maxlength="10">

                    <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3">
                <div class="form-group">
                    <label class="control-label" for="complemento">Complemento</label>

                    <input id="complemento"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.complemento"
                           maxlength="30">
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
                    <label class="control-label" for="bairro">Bairro</label>

                    <input type="text"
                           class="form-control"
                           id="bairro"
                           v-model="solicitacao.bairro"
                           data-vv-as="bairro"
                           data-vv-name="bairro"
                           :disabled="desabilitarEndereco"
                           v-validate="'required'"
                           maxlength="60">

                    <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
                    <label class="control-label" for="cidade">Cidade</label>

                    <input type="text"
                           class="form-control"
                           id="cidade"
                           v-model="solicitacao.cidade"
                           data-vv-as="cidade"
                           data-vv-name="cidade"
                           :disabled="desabilitarEndereco"
                           v-validate="'required'"
                           maxlength="60">

                    <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group required" :class="{'has-error': errors.has('uf')}">
                    <label class="control-label" for="uf">Estado</label>

                    <select id="uf"
                            class="form-control"
                            v-model="solicitacao.uf"
                            data-vv-as="estado"
                            data-vv-name="uf"
                            :disabled="desabilitarEndereco"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('uf')">{{ errors.first('uf') }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-lg-2">
                <div class="form-group required" :class="{'has-error': errors.has('telefone1')}">
                    <label class="control-label" for="telefone1">Telefone 1</label>

                    <input type="text"
                           class="form-control"
                           id="telefone1"
                           v-mascara="'telefone'"
                           v-model="solicitacao.telefone1"
                           data-vv-as="telefone 1"
                           data-vv-name="telefone1"
                           v-validate="'required'">

                    <p class="text-danger" v-show="errors.has('telefone1')">{{ errors.first('telefone1') }}</p>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label" for="telefone2">Telefone 2</label>

                    <input id="telefone2"
                           class="form-control"
                           type="text"
                           v-mascara="'telefone'"
                           v-model="solicitacao.telefone2">
                </div>
            </div>

            <div class="col-xs-2" v-if="tipoTodasSolicitacoesFUSP">
                <div class="required">
                    <label class="control-label" for="funcionarioPublico">Funcionário público</label>
                </div>

                <div class="form-group radios required">
                    <radio v-model="solicitacao.funcionarioPublico"
                           :selected-value="1"
                           type="success"
                           :inline="true"
                           class="margin-right-10">
                        Sim
                    </radio>

                    <radio v-model="solicitacao.funcionarioPublico"
                           :selected-value="0"
                           type="success"
                           :disabled="solicitacao.tipoBolsa == '5'"
                           :inline="true">
                        Não
                    </radio>
                </div>
            </div>

            <div class="col-xs-2" v-if="solicitacao.funcionarioPublico && tipoTodasSolicitacoesFUSP">
                <div :class="[{required: requiredPertenceQuadroUSP}]">
                    <label class="control-label required" for="pertenceQuadroUSP">Pertence ao quadro de funcionários da USP?</label>
                </div>

                <div class="form-group radios">
                    <radio v-model="solicitacao.pertenceQuadroUSP"
                           :selected-value="1"
                           type="success"
                           :inline="true"
                           class="margin-right-10">
                        Sim
                    </radio>

                    <radio v-model="solicitacao.pertenceQuadroUSP"
                           :selected-value="0"
                           type="success"
                           :inline="true">
                        Não
                    </radio>
                </div>
            </div>

            <div class="col-lg-3" v-if="!tipoTodasSolicitacoesFUSP">
                <div :class="['form-group', {'has-error': errors.has('tipoQuadro'), required: solicitacao.pertenceQuadro}]">
                    <checkbox v-model="solicitacao.pertenceQuadro"
                              style="margin-top: 0px;margin-bottom: 5px;"
                              :true-value="true" type="success" :disabled="tipoQuadroSolBolsaObrigatorio">Pertence ao quadro? Qual?</checkbox>

                    <select id="tipo-quadro"
                            class="form-control"
                            v-model="solicitacao.tipoQuadro"
                            data-vv-name="tipoQuadro"
                            data-vv-as="tipo do quadro"
                            v-validate="solicitacao.pertenceQuadro ? 'required' : ''"
                            :disabled="!solicitacao.pertenceQuadro">
                        <option value="">Selecione...</option>
                        <option :value="tipoQuadro.id" v-for="tipoQuadro in tiposQuadro">{{ tipoQuadro.nome }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoQuadro')">{{ errors.first('tipoQuadro') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="!tipoTodasSolicitacoesFUSP">
                <div class="form-group" :class="{'has-error': errors.has('matricula')}">
                    <label class="control-label" for="matricula">Matrícula</label>

                    <input id="matricula"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.matricula"
                           data-vv-as="matricula"
                           data-vv-name="matricula"
                           v-validate="validarMatricula"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('email')">{{ errors.first('matricula') }}</p>
                </div>
            </div>

            <div class="col-lg-3" v-if="!tipoTodasSolicitacoesFUSP">
                <div class="form-group" :class="{'has-error': errors.has('siafi')}">
                    <label class="control-label" for="siafi">SIAPE</label>

                    <input id="siafi"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.siafi"
                           data-vv-as="SIAPE"
                           data-vv-name="siafi"
                           v-validate="validarSiafi"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('siafi')">{{ errors.first('siafi') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="visualizarTipoQuadroRegime">
                <div :class="['form-group', {'has-error': errors.has('tipoQuadroUSP'), required: solicitacao.pertenceQuadroUSP}]">
                    <label class="control-label" for="tipoQuadroUSP">Tipo quadro</label>

                    <select id="tipoQuadroUSP"
                            class="form-control"
                            v-model="solicitacao.tipoQuadroUSP"
                            data-vv-name="tipoQuadroUSP"
                            data-vv-as="tipo do quadro USP"
                            :disabled="this.solicitacao.tipoBolsa === 5"
                            v-validate="solicitacao.pertenceQuadroUSP ? 'required' : ''">
                        <option value="">Selecione...</option>
                        <option :value="tipoQuadroUSP.id" v-for="tipoQuadroUSP in tiposQuadroUSP">{{ tipoQuadroUSP.nome }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoQuadroUSP')">{{ errors.first('tipoQuadroUSP') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="visualizarTipoQuadroRegime">
                <div class="form-group" :class="{'has-error': errors.has('regimeTrabalhoUSP')}">
                    <label class="control-label" for="regimeTrabalhoUSP">Regime de trabalho USP</label>

                    <select id="regimeTrabalhoUSP"
                            class="form-control"
                            v-model="solicitacao.regimeTrabalhoUSP"
                            data-vv-name="regimeTrabalhoUSP"
                            data-vv-as="regime de trabalho USP"
                            v-validate="(solicitacao.tipoQuadroUSP == 1) ? 'required' : ''"
                            @change="limparCamposRegimeTrabalho"
                            :disabled="!(solicitacao.tipoQuadroUSP == 1)">
                        <option value="">Selecione...</option>
                        <option :value="regimeTrabalhoUSP.id" v-for="regimeTrabalhoUSP in regimesTrabalhoUSP">{{ regimeTrabalhoUSP.nome }}</option>
                    </select>

                    <p class="text-danger" v-show="errors.has('regimeTrabalhoUSP')">{{ errors.first('regimeTrabalhoUSP') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="tipoTodasSolicitacoesFUSP && solicitacao.funcionarioPublico && solicitacao.pertenceQuadroUSP != null">
            <div class="col-lg-2">
                <div class="form-group" :class="{'has-error': errors.has('cargo')}">
                    <label class="control-label" for="cargo">Cargo <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="cargo"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.cargo"
                           data-vv-as="cargo"
                           data-vv-name="cargo">

                    <p class="text-danger" v-show="errors.has('cargo')">{{ errors.first('cargo') }}</p>
                </div>
            </div>

            <div class="col-lg-4" v-if="solicitacao.pertenceQuadroUSP">
                <div class="form-group" :class="{'has-error': errors.has('departamento')}">
                    <label class="control-label" for="departamento">Departamento <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="departamento"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.departamento"
                           data-vv-as="departamento"
                           data-vv-name="departamento">

                    <p class="text-danger" v-show="errors.has('departamento')">{{ errors.first('departamento') }}</p>
                </div>
            </div>

            <div class="col-lg-4" v-if="solicitacao.pertenceQuadroUSP">
                <div class="form-group" :class="{'has-error': errors.has('unidade')}">
                    <label class="control-label" for="unidade">Unidade <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="unidade"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.unidade"
                           data-vv-as="unidade"
                           data-vv-name="unidade">

                    <p class="text-danger" v-show="errors.has('unidade')">{{ errors.first('unidade') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="solicitacao.pertenceQuadroUSP == 0">
                <div class="form-group" :class="{'has-error': errors.has('cnpjInstituicaoPublica'), required: requiredCNPJInstituicaoPublica != 'cnpj'}">
                    <label class="control-label" for="cnpjInstituicaoPublica">CNPJ instituição pública <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input type="text"
                           class="form-control"
                           id="cnpjInstituicaoPublica"
                           data-vv-as="cnpj instituição pública"
                           data-vv-name="cnpjInstituicaoPublica"
                           v-mascara="'cnpj'"
                           v-validate="requiredCNPJInstituicaoPublica"
                           v-model="solicitacao.cnpjInstituicaoPublica">

                    <p class="text-danger" v-show="errors.has('cnpjInstituicaoPublica')">{{ errors.first('cnpjInstituicaoPublica') }}</p>
                </div>
            </div>

            <div class="col-lg-4" v-if="solicitacao.pertenceQuadroUSP == 0">
                <div class="form-group" :class="{'has-error': errors.has('instituicaoPublica'), required: requiredInstituicaoPublica}">
                    <label class="control-label" for="instituicaoPublica">Instituição pública <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="instituicaoPublica"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.instituicaoPublica"
                           data-vv-as="instituição pública"
                           v-validate="requiredInstituicaoPublica"
                           data-vv-name="instituicaoPublica">

                    <p class="text-danger" v-show="errors.has('instituicaoPublica')">{{ errors.first('instituicaoPublica') }}</p>
                </div>
            </div>

            <div class="col-lg-2" v-if="solicitacao.pertenceQuadroUSP == 0">
                <div class="form-group" :class="{'has-error': errors.has('cargaHorariaInstituicao')}">
                    <label class="control-label" for="cargaHorariaInstituicao">Carga horária mensal na Instituição <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="cargaHorariaInstituicao"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.cargaHorariaInstituicao"
                           data-vv-as="carga horária na instituição"
                           data-vv-name="cargaHorariaInstituicao">

                    <p class="text-danger" v-show="errors.has('instituicaoPublica')">{{ errors.first('cargaHorariaInstituicao') }}</p>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group" :class="{'has-error': errors.has('matricula1'), required: requiredMatricula}">
                    <label class="control-label" for="matricula1">Matrícula <i class="fa fa-info-circle infoSol" v-tooltip="'INFORMAÇÃO RELEVANTE enviada ao TCE/SP relativo a existência ou inexistência de vínculo funcional com a Administração Pública.'"></i></label>

                    <input id="matricula1"
                           class="form-control"
                           type="text"
                           v-model="solicitacao.matricula"
                           data-vv-as="matricula"
                           data-vv-name="matricula1"
                           v-validate="requiredMatricula"
                           maxlength="20">

                    <p class="text-danger" v-show="errors.has('matricula1')">{{ errors.first('matricula1') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group required" :class="{'has-error': errors.has('email')}">
                    <label class="control-label" for="email">E-mail do beneficiário <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

                    <input type="text"
                           class="form-control"
                           id="email"
                           v-model="solicitacao.email"
                           data-vv-as="e-mail"
                           data-vv-name="email"
                           v-validate="`required|emailcomposto`"
                           maxlength="300"
                           v-caracteres-email>

                    <p class="text-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
                </div>
            </div>
        </div>

    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-bolsa/componentes/compartilhado/FormDadosCadastrais.vue